const {jQuery: $} = window;

export default class TabsLayout {

    #theme;

    /**
     * @param {Theme} theme
     */
    constructor(theme) {
        this.#theme = theme;
    }

    events() {
        const me = this;

        $('.static-tabs .tabbed_section .single_tab__tab').on('click', function () {
            const num = $(this).attr('data-tab');
            const $parent = $(this).parents('.builder-layout');
            const $tabs = $parent.find('.tabbed_section');
            const $content = $parent.find('.tabbed_section__two');
            const $tab = $(this).parents('.single_tab__overtab');
            const $extras = $parent.find('.tabbed_section__extra');

            $content.find('.single_tab__content').removeClass('active').addClass('off');
            $content.find('[data-tab="' + num + '"]').addClass('active').removeClass('off');

            $tabs.find('.single_tab__overtab').removeClass('active').addClass('off');
            $tab.addClass('active').removeClass('off');

            $extras.find('.single_tab__extra').removeClass('active').addClass('off');
            $extras.find('[data-tab="' + num + '"]').addClass('active').removeClass('off');

            $parent.find('.tabbed_section__mobile').html($tab.prop('outerHTML'));
            $parent.find('.tabbed_section__tabs').removeClass('tabbed_section__tabs--open');
        });

        $('.static-tabs .tabbed_section__mobile').on('click', function () {
            const $parent = $('.tabbed_section');
            $parent.find('.tabbed_section__tabs').toggleClass("tabbed_section__tabs--open");
            $parent.find('.tabbed_section__mobile').toggleClass("tabbed_section__mobile--open");
        });

        $('.static-tabs .tabbed_section').each(function (i, el) {
            const $tab = $(el).find('.single_tab__overtab:first-child');
            $(el).find('.tabbed_section__mobile').html($tab.prop('outerHTML'));
            $(el).attr("data-height", $(el).find('.tabbed_section__two').css("max-height"));
        });

    }
}
